import { Select, TimeRangeInput } from '@uplift/ui-v2';
import { Form } from 'formik';
import { SectionContainerContent } from '../../components';
import { useSectionStyles } from '../styles';
import clsx from 'clsx';
import { participantOptions, serviceOptions } from '../../helpers';
import { L10nHTML, useL10n } from '@uplift/hooks';
import { Box } from '@mui/material';


export const Details: React.VFC = () => {
  const l10n = useL10n();
  const { classes } = useSectionStyles();

  return (
    <SectionContainerContent>
      <Form className={classes.formGroup}>
        <Box className={clsx([ classes.formGroup, classes.max336 ])}>
          <Select color="secondary" name="participant" items={participantOptions} label={l10n.clinicalNotes.participants} />
          <Select color="secondary" name="service" items={serviceOptions} label={l10n.clinicalNotes.location} />
        </Box>
        <TimeRangeInput
          color="secondary"
          startTitle={l10n.clinicalNotes.startTime}
          endTitle={l10n.clinicalNotes.endTime}
          name="sessionDuration"
          searchSelect
          endTimeLaterThanStartTime={false}
          endTimeLaterThanStartTimeAsTooltip
          endTimeLaterThanStartTimeMessage={l10n.clinicalNotes.validations.endTimeAfterStartTime}
          lessThenHourWarningTitle=""
          minuteIncrement={5}
          helperText={<L10nHTML variant="body2">{l10n.clinicalNotes.timeShouldReflect}</L10nHTML>}
          disableInclusiveEnd
        />
      </Form>
    </SectionContainerContent>
  );
};
